import type { Maybe } from '@adornis/base/utilTypes.js';

export function extractIDOnlyFromFEKey(feKey: string): string;
export function extractIDOnlyFromFEKey(feKey?: Maybe<string>): string | undefined;
export function extractIDOnlyFromFEKey(feKey?: Maybe<string>) {
  return feKey?.split(':').slice(-1)[0]?.toLowerCase().trim();
}
